import React from 'react';

/**
 * Componente de navegação por abas para o formulário
 */
const TabNavigation = ({ abaAtiva, setAbaAtiva, contadores }) => {
    const abas = [
        { 
            id: "geral", 
            label: "Dados Gerais", 
            icon: "📋",
            description: "Informações básicas do pedido"
        },
        { 
            id: "itens", 
            label: "Itens do Pedido", 
            icon: "📦", 
            badge: contadores.itens,
            description: "Adicione e gerencie os itens"
        },
        {
            id: "anexos",
            label: "Anexos",
            icon: "📎",
            badge: contadores.anexos,
            description: "Documentos e arquivos"
        },
        {
            id: "retencoes",
            label: "Impostos Retidos",
            icon: "💰",
            badge: contadores.retencoes,
            description: "Retenções de impostos do pedido"
        },
        {
            id: "obs",
            label: "Observações",
            icon: "📝",
            description: "Notas e comentários"
        }
    ];

    return (
        <div style={{
            backgroundColor: "white",
            borderRadius: "12px 12px 0 0",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            marginBottom: "0"
        }}>
            <div style={{
                display: "flex",
                borderBottom: "2px solid #E5E7EB",
                padding: "0 24px",
                overflow: "auto"
            }}>
                {abas.map(aba => (
                    <button
                        key={aba.id}
                        onClick={() => setAbaAtiva(aba.id)}
                        title={aba.description}
                        style={{
                            padding: "16px 24px",
                            border: "none",
                            backgroundColor: "transparent",
                            borderBottom: abaAtiva === aba.id ? "3px solid #1E78B4" : "3px solid transparent",
                            color: abaAtiva === aba.id ? "#1E78B4" : "#6B7280",
                            fontWeight: abaAtiva === aba.id ? "600" : "500",
                            fontSize: "14px",
                            cursor: "pointer",
                            transition: "all 0.2s",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            position: "relative",
                            whiteSpace: "nowrap"
                        }}
                    >
                        <span style={{ fontSize: "18px" }}>{aba.icon}</span>
                        <span>{aba.label}</span>
                        {aba.badge !== undefined && aba.badge > 0 && (
                            <span style={{
                                backgroundColor: abaAtiva === aba.id ? "#1E78B4" : "#9CA3AF",
                                color: "white",
                                borderRadius: "12px",
                                padding: "2px 8px",
                                fontSize: "12px",
                                fontWeight: "600",
                                minWidth: "20px",
                                textAlign: "center"
                            }}>
                                {aba.badge}
                            </span>
                        )}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default TabNavigation;
